import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import WarningBox from "components/WarningBox";

import { SubscriptionResponseDto } from "api";

import { basicPlanIds } from "pages/Subscriptions/Subscriptions/variables";

interface Step1Props {
  subscription: SubscriptionResponseDto;
}

const Step1: React.FC<Step1Props> = (props) => {
  const { subscription } = props;
  const { subscriptionDurationDays, paymentPlan } = subscription;

  const isBasicPlan = basicPlanIds.includes(paymentPlan.paymentPlanId);

  const renderDays = (days: number) => {
    const rest = days % 10;

    if (days > 10 && days < 20) {
      return `залишилося ще ${days} днів `;
    }

    switch (rest) {
      case 0:
        return `залишилося ще ${days} днів`;
      case 1:
        return `залишився ще ${days} день`;
      case 2:
      case 3:
      case 4:
        return `залишилося ще ${days} дні`;
      default:
        return `залишилося ще ${days} днів`;
    }
  };

  return (
    <>
      {!isBasicPlan && (
        <Box sx={{ mt: 1, mb: 2 }}>
          <WarningBox content="Посилання з вільною ціною будуть деактивовані після закінчення передплати." />
        </Box>
      )}
      <Typography variant="body1" color="grey800">
        У вас {renderDays(subscriptionDurationDays)}, щоб користуватися всіма
        доступними функціями. Ви впевнені, що хочете припинити використання
        плану?
      </Typography>
    </>
  );
};

export default Step1;
